const stickyElm = document.querySelector(
  ".home #navbar-basic, .page-template-template-video-hero #navbar-basic"
);

if (stickyElm) {
  const observer = new IntersectionObserver(
    ([e]) => e.target.classList.toggle("isSticky", e.intersectionRatio < 1),
    { threshold: [1] }
  );

  observer.observe(stickyElm);
}

function debounce(func, delay) {
  let timeoutId;
  return function (...args) {
    const context = this;
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
}

const setNavBarTop = (searchElm, navBar) => {
  const { top: navBarTop, height: navBarHeight } =
    navBar.getBoundingClientRect();
  searchElm.style.top = `${navBarTop + navBarHeight}px`;
  searchElm.style.maxHeight = `calc(100vh - ${navBarHeight}px)`;
};

const handleSearchbar = () => {
  const searchElm = document.querySelector("#menu-searchbar");
  if (!searchElm) return;
  const navBar = document.querySelector("#navbar-basic");
  if (!navBar) return;
  setNavBarTop(searchElm, navBar);
};

document.addEventListener("DOMContentLoaded", function () {
  handleSearchbar();
});
